<script setup lang="ts">
import SingleMetricResponseDTO = App.Data.Explorer.DataTable.SingleMetricResponseDTO;
import { computed } from "vue";
import { formatNumber } from "chartjs-graph";
import dayjs from "dayjs";
import { formatDateValues } from "@/modules/explorer/components/SingleMetric/util";

const { singleMetric } = defineProps<{
	singleMetric: SingleMetricResponseDTO;
}>();

const displayValue = computed(() => {
	if (typeof singleMetric.data === "number") {
		return formatNumber(singleMetric.data, singleMetric.format);
	}

	return singleMetric.data;
});

const reachedAtDisplayValue = computed(() => {
	if (singleMetric.dimensionValues === undefined) {
		return;
	}

	return formatDateValues(singleMetric.dimensionValues).join(", ");
});
</script>

<template>
	<h1>{{ displayValue }}</h1>
	<p v-if="singleMetric.dimensionValues !== undefined">
		Reached at {{ reachedAtDisplayValue }}
	</p>
</template>

<style scoped lang="scss"></style>
